/**
 * Its contain the Ipaddress. <br>
 * Its contain header for admin and super admin login.
 */
import { environment } from "environments/environment";
export class AppConfig {
    public static get App_Version(): string { return '1.0 Build 1.3'; }
    // public static get IP_Address(): string { return environment.apiURL };
    public static get IP_Redirect(): string { return 'http://localhost:4200/' }
    public static get IP_Address(): any {
        if (environment.production) {
            return document.location.origin + '/';
        } else {
            return environment.apiURL + '/';
        }
    }

    public static getTokenFromUrl(): string {
        const url = window.location.href;
        const tokenParam = "token=";
        const tokenIndex = url.indexOf(tokenParam);
 
        if (tokenIndex !== -1) {
            const token = url.substring(tokenIndex + tokenParam.length);
            const endIndex = token.indexOf('&');
            if (endIndex !== -1) {
                return token.substring(0, endIndex);
            }
            return token;
        } else {
            console.log("Token not found in the URL.");
            return '';
        }
    }
    public static get header_info(): any {
        if (localStorage.loginInfonetApp === undefined) {
            let token: any;
           
            token = this.getTokenFromUrl();
            console.log(token)
            console.log(typeof token)
            if (token) {
                return {
                    'x-auth-token': `${token}`
                };
            } else {
                return {
                    key: 'x-auth-token',
                    value: ''
                };
            }
        }
        else {
            return {
                key: 'x-auth-token',
                value: (JSON.parse(localStorage.loginInfonetApp).token) || ''
            }
        }
 
    }
    public static get LLM_header_info(): any {
        const token = (JSON.parse(localStorage.getItem('loginInfonetApp'))?.token) || '';
        return {
            'x-auth-token': token,
            'Content-Type': 'multipart/form-data' // Although this may be automatically handled by Angular
        };
    }

    public static get header_info_SuperAdmin(): any {
        return {
            key: 'x-auth-token',
            value: (JSON.parse(localStorage.loginInfonetApp).token) || ''
        }
    }
}
